import '../services.css';

const BuisnessBranding = () => {
    return (
        <div className="cover w-100">
            {/* Hero Section */}
            <div className="service-hero-section text-white py-5 text-center bg-primary">
                <h1 className="display-4 fw-bold mb-3">Business Branding</h1>

            </div>

            {/* Web Development Section */}
            <div className="container py-5">
                <div className="row align-items-center">
                    {/* Left - Text */}
                    <div className="col-md-8 mb-4 mb-md-0">
                        <p className="text-justify">
                            In business, reputation is everything and we are here to help you to make your online reputation great. We create World-class logo design with best principles of visual hierarchy. We also help for Re-branding to give your business a new boost.\
                        </p>
                        <p className="text-justify">
                          We’ve been building websites and mobile applications for a while now, so we can help design, develop and manage your product development. The ultimate goal for any product is to help you get new customers and increase your revenue and we utilize technology to bring results to grow your business.
                        </p>
                    </div>

                    {/* Right - Image */}
                    <div className="image-area col-md-4 text-center text-md-end h-100">
                        <img
                            src="assets\images\service\buisness.png"
                            alt="Business Branding"
                            style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                        />
                    </div>
                </div>
            </div>

            {/* Branding Services */}
            <div className="container py-2  ">
                {/* Unique Web Design */}
                <div className="mb-5">
                    <h3 className="h4 fw-semibold mb-3">Branding Services</h3>
                    <p className="text-justify">
                        Our skilled Android app developers create the best apps for the world's largest app store. We develop Android apps that are well-known.
                    </p>
                    <p className="text-justify">
                        Our iPhone app developers create high-quality iOS apps for tech enthusiasts. We create interactive apps that pique the user's interest.
                    </p>
                </div>

            </div>
        </div>
    );
};

export default BuisnessBranding;
